import { render, staticRenderFns } from "./WAndreaniConfirm.vue?vue&type=template&id=1fdef93d&"
import script from "./WAndreaniConfirm.vue?vue&type=script&lang=js&"
export * from "./WAndreaniConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WInput from '@/components/WInput.vue'
import WLoading from '@/components/WLoading.vue'
autoInstallComponents(component, {WInput,WLoading})
